import { useEffect } from 'react';

export const useNotificationRefresh = (reload, eventName) => {
  useEffect(() => {
    window.addEventListener(eventName, reload);
    return () => window.removeEventListener(eventName, reload);
  }, [reload, eventName]);
};
